/* Zeke Squad size guard v6.
   Page renders exactly as the theme always has (S preselected, colors
   untouched). If a shopper who never touched the size row clicks Add
   to Cart or an express pay button, that click is stopped, the page
   scrolls to the sizes, and 'Pick your size first' shows in brand
   pink. Tapping any size clears it.
   v6 fix: forms here contain a hidden input named 'id', which shadows
   the form element's .id property, so we must read the id ATTRIBUTE.
   Undo: delete this file and the script tag at the bottom of
   snippets/product-variant-picker.liquid. */
(function () {
  'use strict';
  var NUDGE_TEXT = 'Pick your size first';
  var PINK = '#FA0191';
  var PREFIX = 'product-form-';
  var touched = {};

  function isSizeFieldset(el) {
    return el && el.className && String(el.className).indexOf('variant-size') !== -1;
  }

  function sizeFieldsetFor(sectionId) {
    var vr = document.querySelector('variant-radios[data-section="' + sectionId + '"]');
    if (!vr) return null;
    var sets = vr.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      if (isSizeFieldset(sets[i])) return sets[i];
    }
    return null;
  }

  function sectionFromFormId(formId) {
    return formId && formId.indexOf(PREFIX) === 0 ? formId.slice(PREFIX.length) : null;
  }

  function markTouched(fs) {
    var vr = fs.closest('variant-radios');
    if (!vr || !vr.dataset.section) return;
    touched[vr.dataset.section] = true;
    var note = fs.querySelector('.zeke-size-nudge');
    if (note) note.style.display = 'none';
  }

  function nudge(fs) {
    try {
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      fs.scrollIntoView();
    }
    var note = fs.querySelector('.zeke-size-nudge');
    if (!note) {
      note = document.createElement('div');
      note.className = 'zeke-size-nudge';
      note.textContent = NUDGE_TEXT;
      note.style.cssText = 'color:' + PINK + ';font-weight:700;margin-top:10px;font-size:1.15em;width:100%;';
      fs.appendChild(note);
    }
    note.style.display = 'block';
  }

  function guard(e, sectionId) {
    if (!sectionId || touched[sectionId]) return;
    var fs = sizeFieldsetFor(sectionId);
    if (!fs) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    nudge(fs);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var fs = t.closest('fieldset');
    if (fs && isSizeFieldset(fs)) {
      markTouched(fs);
      return;
    }

    var btn = t.closest('button[name="add"]');
    if (btn) {
      var formId = btn.getAttribute('form');
      if (!formId) {
        var f = btn.closest('form');
        formId = f ? (f.getAttribute('id') || '') : '';
      }
      guard(e, sectionFromFormId(formId));
      return;
    }

    var pay = t.closest('.shopify-payment-button');
    if (pay) {
      var pf = pay.closest('form');
      guard(e, sectionFromFormId(pf ? (pf.getAttribute('id') || '') : ''));
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var fs = t.closest('fieldset');
    if (fs && isSizeFieldset(fs)) markTouched(fs);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var sectionId = sectionFromFormId(f.getAttribute('id') || '');
    if (sectionId && !touched[sectionId]) {
      var fs = sizeFieldsetFor(sectionId);
      if (fs) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge(fs);
      }
    }
  }, true);
})();
